package dev.lingvo.site.pages.review

/** Capability secrets are accepted only as bounded URL-safe fragments, never as query parameters. */
internal fun publicReviewToken(fragment: String): String? = fragment.removePrefix("#")
    .takeIf { Regex("^[A-Za-z0-9_-]{32,256}$").matches(it) }

/** A fragment is excluded from HTTP requests and referrers; only creation exposes this value. */
internal fun publicReviewLink(origin: String, token: String): String? = publicReviewToken(token)?.let {
    "${origin.trimEnd('/')}/review/screenshots#$it"
}
